import { useSyncExternalStore } from 'react';

export interface ToastItem {
  id: number;
  message: string;
  action?: { label: string; run: () => void };
}

let toasts: ToastItem[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function toast(message: string, action?: ToastItem['action'], durationMs = 3000): void {
  const item: ToastItem = { id: nextId++, message, ...(action ? { action } : {}) };
  toasts = [...toasts, item];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== item.id);
    emit();
  }, durationMs);
}

export function ToastHost() {
  const items = useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => toasts,
  );
  return (
    <div className="lm-toasts" aria-live="polite">
      {items.map((t) => (
        <div key={t.id} className="lm-toast" role="status" data-testid="toast">
          {t.message}
          {t.action && (
            <button
              onClick={() => {
                t.action!.run();
                toasts = toasts.filter((x) => x.id !== t.id);
                emit();
              }}
            >
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
